// src/components/PrivateRoute.tsx
import type React from "react";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useGlobal } from "@/context/GlobalContext";
import Loading from "@/components/Shared/Loading";
import { preloadProtectedPages } from "@/routes";

const PrivateRoute: React.FC = () => {
    const { isAuthenticated, isLoading, PreviewMode } = useGlobal();

    // Fetch the other signed-in pages' code in the background, so moving between them does not stall.
    useEffect(() => {
        if (isAuthenticated) preloadProtectedPages();
    }, [isAuthenticated]);

    if (PreviewMode) {
        return <Outlet />;
    }

    return (
        <>
            {isAuthenticated
                ? <Outlet />
                : isLoading
                    ? null                        // wait for auth check before deciding
                    : <Navigate to="/" replace />  // confirmed not authenticated
            }
            <Loading message="Loading..." fullscreen visible={isLoading} />
        </>
    );
};

export default PrivateRoute;
